import call from "@kinetics254/cassandra-base/service/http";
import constants from "./LeaveRecallConstants";

export default {
  namespaced: true,
  state: {
    leaveApplicationOptions: [],
    recall: null,
  },
  mutations: {
    MUTATE: (state, payload) => {
      state[payload.state] = payload.data;
    },
  },
  getters: {
    leaveRecallGetters: (state) => (val) => state[val],
  },
  actions: {
    getRecalls: async ({ commit }, params) => {
      try {
        return await call("get", constants.getRecalls(params));
      } catch (error) {
        Event.$emit("ApiError", error.response.data.message);
        throw error;
      }
    },
    getRecall: async ({ commit }, recallNo) => {
      try {
        const res = await call("get", constants.getRecall(recallNo));

        commit("MUTATE", {
          state: "recall",
          data: res.data.data,
        });
      } catch (error) {
        Event.$emit("ApiError", error.response.data.message);
        throw error;
      }
    },
    saveRecall: async ({ commit, dispatch }, data) => {
      try {
        await call("post", constants.saveRecall, data);
        Event.$emit("ApiSuccess", "Leave recall saved successfully");
        if (data.recallNo) {
          dispatch("getRecall", data.recallNo);
        } else {
          dispatch("getRecalls", {
            requestedByEmployeeNo: data.requestedByEmployeeNo,
          });
        }
      } catch (error) {
        Event.$emit("ApiError", error.response.data.message);
        throw error;
      }
    },

    submitRecall: async ({ commit, dispatch }, { recallNo }) => {
      try {
        await call("post", constants.submitRecall, {
          recallNo,
        });
        Event.$emit("ApiSuccess", "Leave recall submitted successfully");
        dispatch("getRecall", recallNo);
      } catch (error) {
        Event.$emit("ApiError", error.response.data.message);
        throw error;
      }
    },

    sendForApproval: async ({ commit, dispatch }, { recallNo }) => {
      try {
        await call("post", constants.sendRecallForApproval, {
          recallNo,
        });
        Event.$emit("ApiSuccess", "Leave recall sent for approval");
        dispatch("getRecall", recallNo);
      } catch (error) {
        Event.$emit("ApiError", error.response.data.message);
        throw error;
      }
    },

    reopenRecall: async ({ commit, dispatch }, { recallNo }) => {
      try {
        await call("post", constants.reopenRecall, { recallNo });
        Event.$emit("ApiSuccess", "Approval request canceled successfully");
        dispatch("getRecall", recallNo);
      } catch (error) {
        Event.$emit("ApiError", error.response.data.message);
        throw error;
      }
    },

    acceptRecall: async ({ commit, dispatch }, { recallNo }) => {
      try {
        await call("post", constants.acceptRecall, {
          recallNo,
        });
        Event.$emit("ApiSuccess", "Leave recall accepted successfully");
        dispatch("getRecall", recallNo);
      } catch (error) {
        Event.$emit("ApiError", error.response.data.message);
        throw error;
      }
    },

    denyRecall: async ({ commit, dispatch }, { recallNo }) => {
      try {
        await call("post", constants.denyRecall, { recallNo });
        Event.$emit("ApiSuccess", "Leave recall rejected successfully");
        dispatch("getRecall", recallNo);
      } catch (error) {
        Event.$emit("ApiError", error.response.data.message);
        throw error;
      }
    },

    deleteRecall: async (
      { commit, dispatch },
      { recallNo, requestedByEmployeeNo }
    ) => {
      try {
        await call("post", constants.deleteRecall, { recallNo });
        Event.$emit("ApiSuccess", "Leave recall deleted successfully");
        dispatch("getRecalls", {
          requestedByEmployeeNo: requestedByEmployeeNo,
        });
      } catch (error) {
        Event.$emit("ApiError", error.response.data.message);
        throw error;
      }
    },

    getLeaveApplicationOptions: ({ commit }, params) => {
      commit("loader/SET_LOADING", true, { root: true });
      call("get", constants.leaveApplicationOptions(params))
        .then((res) => {
          commit("MUTATE", {
            state: "leaveApplicationOptions",
            data: res.data.data,
          });
          commit("loader/SET_LOADING", false, { root: true });
        })
        .catch((error) => {
          Event.$emit("ApiError", error.response.data.message);
          commit("loader/SET_LOADING", false, { root: true });
        });
    },
  },
};
